import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription, fromEvent } from 'rxjs';
import { startWith } from 'rxjs';
import { AppLoginService } from '../app-login.service';
import { LocalService } from '@app/@core/services/local.service';

@Component({
  standalone: false,
  selector: 'app-forgot-email',
  templateUrl: './forgot-email.component.html',
  styleUrls: ['./forgot-email.component.scss']
})
export class ForgotEmailComponent implements OnInit, OnDestroy {
  recoveryForm: FormGroup;
  isSubmitting = false;
  isMobile = false;
  logoPath = 'assets/images/edu-logo.svg';
  resizeObservable$: Subscription | undefined;

  constructor(private readonly fb: FormBuilder, private readonly router: Router, private readonly appLoginService: AppLoginService , private sessionStorage: LocalService,) {}

  ngOnInit(): void {
    this.initForm();
    this.setupResponsiveImage();
  }

  ngOnDestroy(): void {
    if (this.resizeObservable$) {
      this.resizeObservable$.unsubscribe();
    }
  }

   setupResponsiveImage(): void {
      this.resizeObservable$ = fromEvent(window, 'resize').pipe(startWith({} as Event))
        .subscribe(() => {
          this.isMobile = window.innerWidth < 768;
          this.updateLogoPath();
        });
      
      this.isMobile = window.innerWidth < 768;
      this.updateLogoPath();
    }

    updateLogoPath(): void {
    this.logoPath = this.isMobile 
      ? 'assets/images/cardy-ai/mobile-logo.svg'
      : 'assets/images/edu-logo.svg';
  }

  initForm(): void {
    this.recoveryForm = this.fb.group({
      method: ['email'],
      recoveryEmail: ['', [
        Validators.required,
        Validators.email
      ]],
      phoneNumber: ['', [
        Validators.pattern('^(\\+?1\\s?)?\\(?[2-9]\\d{2}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$')
      ]]
    });

    this.recoveryForm.get('method').valueChanges.subscribe(method => {
      if (method === 'email') {
        this.recoveryForm.get('recoveryEmail').setValidators([Validators.required, Validators.email]);
        this.recoveryForm.get('phoneNumber').setValidators(null);
        this.recoveryForm.get('phoneNumber').setValue('');
      } else {
        this.recoveryForm.get('phoneNumber').setValidators([
          Validators.required,
          Validators.pattern('^(\\+?1\\s?)?\\(?[2-9]\\d{2}\\)?[\\s.-]?\\d{3}[\\s.-]?\\d{4}$')
        ]);
        this.recoveryForm.get('recoveryEmail').setValidators(null);
        this.recoveryForm.get('recoveryEmail').setValue('');
      }
      this.recoveryForm.get('recoveryEmail').updateValueAndValidity();
      this.recoveryForm.get('phoneNumber').updateValueAndValidity();
    });
  }

  
  isValidEmail(email: string): boolean {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }
  
  onSubmit(): void {
    
    const method = this.recoveryForm.get('method').value;
    if (method === 'email') {
      const email = this.recoveryForm.get('recoveryEmail').value;
      if (!this.isValidEmail(email)) {
        this.recoveryForm.get('recoveryEmail').setErrors({'email': true});
        return;
      }
    }
    
    if (this.recoveryForm.valid) {
      
      this.isSubmitting = true;
      const request = {
        email: this.recoveryForm.get('recoveryEmail')?.value
      };
      this.appLoginService.recoveryEmailVerification(request).subscribe({
        next: (response) => {
          this.isSubmitting = false;
          
          
          const email = this.recoveryForm.get('recoveryEmail')?.value;
          this.sessionStorage.setItem('recoveryEmail', email);
          
          
          this.router.navigate(['app-login/email-otp-verification'], {
            state: { email: email } 
          });
        },
        error: () => {
          this.isSubmitting = false;
          
        }
      });
    } else {
      
      Object.keys(this.recoveryForm.controls).forEach(key => {
        const control = this.recoveryForm.get(key);
        if (control) {
          control.markAsTouched();
        }
      });
    }
  }

}
